<script>
import { sync } from 'vuex-pathify'

export default {
	lang: 'shop',
	data() {
		return {
			loading: true,
			words: [],
			products: [],
			fullText: '',
			typingInterval: null,
			visibleWords: 0,
			textStyle: null,
		}
	},
	/* 	metaInfo() {
		const { siteName, separator } = this.$srv('SitePageTitle', {})
		return { title: `${siteName} ${separator} ${this.$route.query.search}` }
	}, */
	watch: {
		'$route.query.search': function (newVal) {
			if (newVal) {
				this.aiSearch()
			} else {
				this.$shop.goShop()
			}
		},
	},
	async mounted() {
		if (!this.$route.query.search) {
			this.$shop.goShop()
			return
		}
		this.searchMode = 'ai'
		this.aiSearch().then(() => {
			if (!this.$b.m) {
				const appbarRect = document.querySelector('.appbar').getBoundingClientRect()
				this.textStyle = {
					top: `${appbarRect.height}px`,
					position: 'sticky',
				}
			}
		})
	},
	computed: {
		searchMode: sync('shop/searchMode'),
	},
	methods: {
		async aiSearch() {
			return this.$shopApi.post({
				url: '/catalog/ai-search',
				loading: (v) => (this.loading = v),
				data: {
					search: this.$route.query.search,
				},
				onSuccess: ({ data }) => {
					this.fullText = data.text
					this.products = data.products
					this.simulateTyping()
				},
			})
		},
		simulateTyping() {
			this.visibleWords = 0
			this.words = this.fullText.split(' ')
			if (this.typingInterval) clearInterval(this.typingInterval)

			const showNextWord = () => {
				if (this.visibleWords < this.words.length) {
					this.visibleWords++

					const delay = Math.random() * 50
					if (this.typingInterval) {
						clearInterval(this.typingInterval)
					}
					this.typingInterval = setTimeout(showNextWord, delay)
				}
			}

			showNextWord()
		},
	},
	beforeDestroy() {
		if (this.typingInterval) clearInterval(this.typingInterval)
	},
}
</script>

<template>
	<Container class="ai-search-result mt-4">
		<h1 class="font-4 text-center my-4"></h1>
		<v-row>
			<v-col class="__left" cols="12" md="4">
				<div :style="textStyle">
					<div class="font-2 my-2">
						{{ $route.query.search }}
					</div>
					<!-- <hr class="my-1" /> -->
					<div v-if="loading">
						<v-skeleton-loader type="text" />
						<v-skeleton-loader type="text" />
						<v-skeleton-loader type="text" width="70%" />
					</div>
					<div v-else class="font-2">
						<span
							v-for="(word, index) in words"
							:key="index"
							class="word"
							:class="{ 'fade-in': visibleWords > index }"
							>{{ word }}</span
						>
					</div>
				</div>
			</v-col>
			<v-col class="__right" cols="12" md="8">
				<ProductsLayout :products="products" :loading="loading" />
			</v-col>
		</v-row>
	</Container>
</template>

<style scoped lang="scss">
.word {
	display: inline-block;
	opacity: 0;
	margin-right: 4px;
	transition: opacity 0.3s ease;
}
.fade-in {
	opacity: 1;
}

.fade-letter:nth-child(n) {
	opacity: 1;
}

.ai-search-result {
	.__left {
		::v-deep .v-skeleton-loader__text {
			height: 24px;
		}
	}
}
</style>

